import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useAuth } from "@/features/auth/context/AuthContext";
import { isAdmin } from "@/lib/auth-utils";
import { useTranslation } from "react-i18next";

export function SettingsSidebar() {
  const { t } = useTranslation("common");
  const { profile } = useAuth();
  const showCompanySettings = isAdmin(profile.role);

  const personalSettingsItems = [
    {
      title: "Profil",
      href: "/settings/profile"
    },
    {
      title: "Benachrichtigungen",
      href: "/settings/notifications"
    },
    {
      title: t("cookies.management.title"),
      href: "/settings/manage-cookies"
    }
    /*
    {
      title: "Darstellung",
      href: "/settings/appearance"
    }*/
  ];

  const companySettingsItems = [
    {
      title: "Unternehmen",
      href: "/settings/company"
    },
    /*
    {
      title: "Gesellschaften",
      href: "/settings/subsidiaries"
    },*/
    {
      title: "Einrichtungen",
      href: "/settings/facilities"
    },
    /*
    {
      title: "Stellenprofile",
      href: "/settings/job-profiles"
    },*/
    {
      title: "Stellenangebote",
      href: "/settings/jobs"
    }
  ];

  const superuserSettingsItems = [
    {
      title: "Unternehmen",
      href: "/settings/companies"
    },
    {
      title: "Accounts",
      href: "/settings/users"
    },
    {
      title: "Erforderliche Dokumente",
      href: "/settings/required-documents"
    },
    {
      title: "Dokumentenliste",
      href: "/settings/documents-list"
    }
  ];

  return (
    <nav className="w-64 p-4">
      <div className="flex flex-col">
        {/* Personal Settings */}
        <div className="mb-4">
          <div className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-2 px-3">
            Persönlich
          </div>
          <div className="space-y-1">
            {personalSettingsItems.map((item) => (
              <NavLink
                key={item.href}
                to={item.href}
                className={({ isActive }) =>
                  cn(
                    "block px-3 py-1.5 text-sm font-medium rounded-sm transition-colors",
                    isActive
                      ? "bg-gray-100 text-gray-900"
                      : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                  )
                }
              >
                {item.title}
              </NavLink>
            ))}
          </div>
        </div>

        {/* Company Settings */}
        {showCompanySettings && (
          <div className="mb-4">
            <div className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-2 px-3">
              Workinger GmbH
            </div>
            <div className="space-y-1">
              {companySettingsItems.map((item) => (
                <NavLink
                  key={item.href}
                  to={item.href}
                  className={({ isActive }) =>
                    cn(
                      "block px-3 py-1.5 text-sm font-medium rounded-sm transition-colors",
                      isActive
                        ? "bg-gray-100 text-gray-900"
                        : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                    )
                  }
                >
                  {item.title}
                </NavLink>
              ))}
            </div>
          </div>
        )}

        {/* Superuser Administration */}
        {profile.isSuperUser && (
          <div>
            <div className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-2 px-3">
              Administration
            </div>
            <div className="space-y-1">
              {superuserSettingsItems.map((item) => (
                <NavLink
                  key={item.href}
                  to={item.href}
                  className={({ isActive }) =>
                    cn(
                      "block px-3 py-1.5 text-sm font-medium rounded-sm transition-colors",
                      isActive
                        ? "bg-gray-100 text-gray-900"
                        : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                    )
                  }
                >
                  {item.title}
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
